import { CSSProperties, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Sidebar, CloseButton, BackArrow, Backdrop, Title } from "./styles";
import { Transition } from "react-transition-group";
import Icon from "../Icon";
import { AnimationFixed, Animation } from "../Animation";
import leftArrow from "../../assets/icons/icon-cool/outline/Arrows-chevron/Left.svg";
import close from "../../assets/icons/icon-cool/outline/Close.svg";

interface ComponentProps {
  position?: "left" | "right" | "bottom" | "top";
  children: any;
  visible: boolean;
  onClose?: () => void;
  closeType?: "close" | "back";
  styles?: CSSProperties;
  width?: string;
  height?: string;
  title: string;
}

const animationByPosition = {
  left: "fadeInSlideLeft",
  top: "fadeInSlideDown",
  bottom: "fadeInSlideUp",
  right: "fadeInSlideRight",
};

const Component = ({
  position = "left",
  children,
  visible,
  onClose,
  closeType,
  styles,
  width,
  height,
  title,
}: ComponentProps) => {
  const [isVisible, setIsVisible] = useState(visible);
  const animation = animationByPosition[position];

  const sidebar = document.getElementById("sidebar") as HTMLElement;

  if (!sidebar) {
    throw new Error("Element with id 'sidebar' not found in the document");
  }

  const preventBodyScroll = () => {
    if (visible) {
      document.body.style.height = "100%";
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.height = "auto";
      document.body.style.overflow = "auto";
    }
  };

  const handleClose = () => {
    setIsVisible(false);

    if (onClose) {
      onClose();
    }
  };

  useEffect(() => {
    setIsVisible(visible);
    preventBodyScroll();
  }, [visible]);

  return createPortal(
    <Transition in={isVisible} timeout={300}>
      {(state) => (
        <>
          <AnimationFixed
            name={animation}
            className={`animation-${state}`}
            duration={0.5}
            width={width}
            height={height}
            position={position}
            {...(!!styles && styles)}
          >
            <Sidebar>
              {closeType && closeType === "close" && (
                <CloseButton type="button" onClick={handleClose}>
                  <Icon
                    icon={close}
                    color="rgba(45, 52, 54, 0.75)"
                    size="24px"
                  />
                </CloseButton>
              )}

              <Title>
                {closeType && closeType === "back" && (
                  <BackArrow type="button" onClick={handleClose}>
                    <Icon
                      icon={leftArrow}
                      color="rgba(45, 52, 54, 0.75)"
                      size="24px"
                    />
                  </BackArrow>
                )}
                <span>{title}</span>
              </Title>

              {children}
            </Sidebar>
          </AnimationFixed>

          <Animation name="fadeIn" className={`animation-${state}`}>
            <Backdrop onClick={handleClose} />
          </Animation>
        </>
      )}
    </Transition>,
    sidebar
  );
};

export default Component;
